import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { BreadCrumbData } from '@redux/common/types';
import { ReduxState } from '@redux/types';
import NavTopBarContentWrapper from '../../components/NavTopBarContentWrapper/NavTopBarContentWrapper';
import style from './CareGroup.scss';

interface Props {
  breadCrumbs: BreadCrumbData[];
  appendBreadCrumbs: (breadCrumb: BreadCrumbData, defaultCrumbHistory: BreadCrumbData[]) => void;
  startLogout: () => void;
}

const CareGroup: React.FC<Props> = ({ appendBreadCrumbs }) => {
  return (
    <NavTopBarContentWrapper centerAlignContent headerText="Care Group">
      <div className={style.mainContainer}></div>
    </NavTopBarContentWrapper>
  );
};

const connectRedux = connect(
  (state: ReduxState) => ({}),
  (dispatch: Function) => ({})
);

export default compose(connectRedux)(CareGroup);
